import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useSelector } from 'react-redux'

const ModulePreAssessment = ({ setSelectedSidebarItem }) => {
  const location = useLocation()
  const moduleId = location.state?.moduleId || location.state
  const userId = useSelector(state => state.user.user?.data.id)
  // console.log('userId', userId)
  const [preQuestions, setPreQuestions] = useState([])
  const [selectedAnswer, setSelectedAnswer] = useState(null)
  const [userResponses, setUserResponses] = useState([])
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0)

  const [selectedAnswers, setSelectedAnswers] = useState([])

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await axios.post('/api/module/fetchPreQuestion', {
          moduleId
        })

        setPreQuestions(response.data.data)
      } catch (error) {
        console.error('Error fetching questions:', error)
        setPreQuestions([])
      }
    }

    fetchQuestions()
  }, [moduleId])

  const handleAnswerChange = event => {
    const answerId = event.target.value
    const isChecked = event.target.checked

    if (isChecked) {
      // Add the selected answer to the list
      setSelectedAnswers(prevSelectedAnswers => [
        ...prevSelectedAnswers,
        answerId
      ])
    } else {
      // Remove the unselected answer from the list
      setSelectedAnswers(prevSelectedAnswers =>
        prevSelectedAnswers.filter(id => id !== answerId)
      )
    }
  }

  const handleNext = () => {
    if (selectedAnswer) {
      setUserResponses(prevResponses => [
        ...prevResponses,
        {
          questionId: preQuestions[currentQuestionIndex].id,
          answerId: selectedAnswer
        }
      ])

      setCurrentQuestionIndex(prevIndex => prevIndex + 1)
      setSelectedAnswer(null)
    } else {
      // User must select an answer before proceeding
      alert('Please select an answer before proceeding.')
    }
  }

  const handleSubmit = () => {
    if (selectedAnswers.length > 0) {
      setUserResponses(prevResponses => [
        ...prevResponses,
        {
          questionId: preQuestions[currentQuestionIndex].id,
          answerIds: selectedAnswers // Use an array for multiple selected answers
        }
      ])

      setCurrentQuestionIndex(prevIndex => prevIndex + 1)
      setSelectedAnswers([]) // Clear the selected answers for the next question
    } else {
      // User must select at least one answer before proceeding
      alert('Please select at least one answer before proceeding.')
    }
  }

  const submitAnswer = () => {
    const updateAssessment = async () => {
      try {
        const response = await axios.post(
          '/api/module/updatePreAssessmentStatus',
          {
            userResponses,
            userId,
            moduleId
          }
        )
        if (response.status === 200) {
          setSelectedSidebarItem('Video')
        } else {
          console.log('Failed to update assessment status')
        }
      } catch (error) {
        console.error('Error updating assessment status:', error)
      }
    }

    updateAssessment()
  }

  return (
    <div className="video">
      <div className="assessment-container">
        <div style={{ padding: '50px' }}>
          {Array.isArray(preQuestions) &&
          preQuestions.length > 0 &&
          currentQuestionIndex < preQuestions.length ? (
            <div key={preQuestions[currentQuestionIndex].id}>
              {preQuestions[currentQuestionIndex].id ===
                '197d9a72-fab4-4856-a0aa-b4232c933eca' && (
                <section className="mb-4">
                  <h5>Case Scenario Child M </h5>
                  <div>
                    <p>
                      Child M is a 3-year-old boy who was recently admitted for
                      acute gastroenteritis (AGE) with 8% dehydration. He has no
                      known underlying medical conditions.
                    </p>
                    <p>
                      Prior to admission, his best recorded weight was 10.5 kg,
                      which falls between -2 to -3 SD for age. His length was 85
                      cm (-2 SD), indicating growth concerns.
                    </p>
                    <p>
                      Dietary history revealed that Child M had stopped
                      breastfeeding and was not receiving any regular milk or
                      formula feeds. His mother expressed concern regarding his
                      solid food intake and reported that he tends to eat better
                      when spoon-fed.{' '}
                    </p>
                    <p>
                      His usual meals consist of rice mixed with soup or gravy,
                      along with small pieces of chicken. However, he is often
                      unable to finish more than one scoop (approximately ½ cup)
                      of rice. His mother noted that he has a better appetite
                      when offered pasta or noodles instead.{' '}
                    </p>
                    The mother described him as very active at home and stated
                    that he frequently continues playing during mealtimes. To
                    encourage eating, she allows him to watch television, which
                    helps settle him and enables her to spoon-feed him within
                    approximately 30 minutes before the family dinner time.Which
                    of the following statement is true about this case scenario?
                  </div>
                </section>
              )}
              <div className="d-flex">
                <div>{`${currentQuestionIndex + 1}.`}</div>
                <div className="ms-2">
                  {preQuestions[currentQuestionIndex].question}
                </div>
              </div>
              <div className="mt-3 ms-3">
                {Array.isArray(preQuestions[currentQuestionIndex].PreAnswers) &&
                  preQuestions[currentQuestionIndex].PreAnswers.map(answer => (
                    <div key={answer.id} className="mb-3">
                      <label className="d-flex">
                        <input
                          type="checkbox" // Change the input type to checkbox
                          name={`question_${preQuestions[currentQuestionIndex].id}`}
                          value={answer.id}
                          checked={selectedAnswers.includes(answer.id)}
                          onChange={handleAnswerChange}
                          className="mt-1 me-2 align-self-start"
                        />
                        {answer.answer}
                      </label>
                    </div>
                  ))}
              </div>

              <button
                style={{
                  margin: '0 auto',
                  display: 'block',
                  marginTop: '20px',
                  padding: '10px 40px'
                }}
                htmlType="button"
                onClick={handleSubmit}
              >
                {currentQuestionIndex < preQuestions.length - 1
                  ? 'Next'
                  : 'Submit'}
              </button>
            </div>
          ) : (
            <div style={{ margin: 'auto', padding: '10px 40px' }}>
              <button onClick={submitAnswer}>Submit Answer</button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ModulePreAssessment
